export const ROUTE_PERMISSIONS: Record<string, string> = {
  "/customers": "CUSTOMERS",
  "/partners": "PARTNERS",
  "/trades": "TRADES",
  "/loans": "LOANS",
  "/payments": "PAYMENTS",
  "/reports": "REPORTS",
  "/markets": "MARKETS",
  "/risk-engine": "RISK_ENGINE",
  "/price-prediction": "PRICE_PREDICTION",
  "/my-profile": "MY_PROFILE",
};
